import React from "react"
import { Link } from "gatsby"
import { Card, Avatar, Skeleton } from "antd"

const { Meta } = Card

export const createHomepageBlock = post => {
  try {
    const { slug, title, socialPhoto, author } = post
    const {
      image: { url = null },
    } = socialPhoto
    const { displayName } = author

    return (
      <div className="homepage-block">
        <Link to={`/post/${slug}`}>
          <Card
            hoverable
            style={{ width: 300 }}
            cover={<img alt={title} src={url} />}
          >
            <Meta
              title={title}
              description={<div className="user-container">{displayName}</div>}
            />
          </Card>
        </Link>
      </div>
    )
  } catch (e) {
    return null
  }
}
